import { useNavigate, useLocation } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAuth } from '../../context/AuthContext';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Avatar
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';

export const headerHeight = { xs: 64, sm: 64 };

function Header({ menuOpen, onMenuToggle }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState('');
  const title = ({ dashboard: 'Genel Bakış', users: 'Kullanıcılar', reports: 'Raporlar', 'card-shares': 'Kart Paylaşımları', support: 'Destek', settings: 'Ayarlar' })[location.pathname.split('/')[1]] || 'Genel Bakış';
  const { admin, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
    handleClose();
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { xs: '100%', md: 'calc(100% - 284px)' },
        zIndex: (theme) => ({ xs: theme.zIndex.appBar, md: theme.zIndex.drawer + 1 }),
        backgroundColor: 'white',
        borderBottom: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)'
      }}
    >
      <Toolbar sx={{ minHeight: headerHeight, px: { xs: 2, sm: 3 }, gap: 1 }}>
        <IconButton
          aria-label="Ana menüyü aç"
          aria-controls="admin-navigation"
          aria-expanded={menuOpen}
          onClick={onMenuToggle}
          edge="start"
          sx={{ display: { xs: 'inline-flex', md: 'none' }, color: '#334155' }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="h6"
              component="div"
              noWrap
              sx={{
                fontWeight: 700,
                fontSize: { xs: '16px', sm: '18px' },
                color: '#111827'
              }}
            >
              {title}
            </Typography>
          </Box>
          <Box component="form" onSubmit={(event) => { event.preventDefault(); navigate(`/users?search=${encodeURIComponent(search.trim())}`); }} sx={{ display: { xs: 'none', lg: 'flex' }, alignItems: 'center', gap: 1, ml: 2, px: 1.5, height: 40, width: 'min(42vw, 490px)', border: '1px solid #e8edf6', borderRadius: 3, bgcolor: '#f3f6fc', color: '#8998b4' }}>
            <SearchIcon fontSize="small" />
            <input aria-label="Kullanıcı ara" placeholder="Kullanıcı ara…" value={search} onChange={(event) => setSearch(event.target.value)} style={{ background: 'transparent', border: 0, outline: 0, width: '100%', color: '#263957', font: 'inherit', fontSize: 13 }} />
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexShrink: 0 }}>
          <IconButton aria-label="Destek taleplerini aç" onClick={() => navigate('/support')} sx={{ color: '#64728e' }}><MailOutlineIcon /></IconButton>
          {/* User Info */}
          <Box component="button" type="button" aria-label="Hesap menüsünü aç"
            sx={{
              display: 'flex',
              border: 0,
              borderLeft: '1px solid #edf0f5',
              alignItems: 'center',
              gap: 1.5,
              padding: '6px 12px',
              borderRadius: '12px',
              backgroundColor: 'transparent',
              cursor: 'pointer',
              transition: 'all 0.2s',
              '&:hover': {
                backgroundColor: '#F1F5F9'
              }
            }}
            onClick={handleMenu}
          >
            <Box sx={{ textAlign: 'left', order: 1, display: { xs: 'none', sm: 'block' } }}>
              <Typography variant="body2" sx={{ fontSize: '14px', fontWeight: 600, color: '#1F2937' }}>
                {admin?.name || 'Admin'}
              </Typography>
              <Typography variant="caption" sx={{ fontSize: '12px', color: '#6B7280' }}>
                {admin?.role === 'super-admin' ? 'Süper Admin' : 'Admin'}
              </Typography>
            </Box>
            <Avatar
              sx={{
                width: 40,
                height: 40,
                background: 'linear-gradient(135deg, #40A2E3 0%, #2E86C1 100%)',
                fontWeight: 700,
                fontSize: '16px',
                boxShadow: '0 4px 6px rgba(64, 162, 227, 0.2)'
              }}
            >
              {admin?.name?.charAt(0)?.toUpperCase() || 'A'}
            </Avatar>
            <ExpandMoreIcon sx={{ order: 2, color: '#6b7a94', fontSize: 20 }} />
          </Box>

          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right'
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            PaperProps={{
              sx: {
                mt: 1.5,
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                minWidth: 200
              }
            }}
          >
            <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid #E5E7EB' }}>
              <Typography variant="body2" sx={{ fontWeight: 600, color: '#1F2937' }}>
                {admin?.name || 'Admin'}
              </Typography>
              <Typography variant="caption" sx={{ color: '#6B7280' }}>
                {admin?.email}
              </Typography>
            </Box>
            <MenuItem
              onClick={handleLogout}
              sx={{
                py: 1.5,
                gap: 1.5,
                color: '#EF4444',
                '&:hover': {
                  backgroundColor: '#FEF2F2'
                }
              }}
            >
              <LogoutIcon sx={{ fontSize: 20 }} />
              Çıkış Yap
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
